<template>
  <tab-layout :full-width="true">
    <form
      slot="tabContent"
      class="row mx-0"
      novalidate
      @submit.prevent="handleSubmit"
    >
      <div class="col px-0 pr-lg-3">
        <div class="bg-white rounded mb-4 p-3">
          <page-heading>Create Event</page-heading>

          <event-form
            :events="events"
            :shared-form="sharedForm"
            :event-types="eventTypes"
            :loading-types="loadingTypes"
            :is-combined="isCombined"
            :errors="errors"
            :alert="{ message: alert.message.value, type: alert.type.value }"
            :available-judges="availableJudges"
            :loading-judges="loadingJudges"
            :judge-ids="judgeIds"
            @toggle-combined="onCombinedToggle"
            @update-shared="onUpdateShared"
            @update-event="updateEvent"
            @logo-change="onLogoChange"
            @remove-logo="sharedForm.sponsor_logo = null"
            @update-judge-ids="updateJudgeSelection"
            @search-judges="searchJudges"
          />

          <!-- Mobile submit -->
          <mobile-submit-button :loading="submitting">
            Create
          </mobile-submit-button>
        </div>
      </div>

      <!-- Desktop action bar -->
      <desktop-action-bar>
        <app-button type="submit" class="px-md-5" :loading="submitting">
          Create
        </app-button>
      </desktop-action-bar>

    </form>
  </tab-layout>
</template>

<script>
import { defineComponent, onMounted, getCurrentInstance } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import EventBus from '@/store/EventBus'
import EventForm from '@/components/Events/EventForm'
import MobileSubmitButton from '@/components/MobileSubmitButton'
import AppButton from '@/components/AppButton'
import DesktopActionBar from '@/components/DesktopActionBar'
import useEventCreate from '@/composables/events/useEventCreate'

export default defineComponent({
  name: 'SecretaryEventCreate',
  components: { TabLayout, PageHeading, EventForm, MobileSubmitButton, AppButton, DesktopActionBar },
  props: {
    draftId: { type: [String, Number], required: true }
  },
  setup(props) {
    const vm = getCurrentInstance()
    const proxy = vm.proxy

    const {
      eventTypes,
      loadingTypes,
      isCombined,
      events,
      sharedForm,
      errors,
      submitting,
      alert,
      availableJudges,
      loadingJudges,
      judgeIds,
      loadEventTypes,
      searchJudges,
      updateEvent,
      updateJudgeSelection,
      updateShared,
      submit
    } = useEventCreate(props.draftId)

    onMounted(() => {
      loadEventTypes()
      searchJudges('')
      proxy.$nextTick(() => {
        proxy.$root.$emit('update-breadcrumb', { name: 'View Draft', link: `drafts/view/${props.draftId}` })
      })
    })

    function onCombinedToggle(val) {
      isCombined.value = val
      if (!val) {
        updateShared({ is_conjunction: false, discount_price: '' })
      }
    }

    function onUpdateShared(field, val) {
      updateShared({ [field]: val })
    }

    function onLogoChange(file) {
      sharedForm.sponsor_logo = file
    }

    async function handleSubmit() {
      const message = await submit()
      if (message) {
        proxy.$router.push({ name: 'Draft View', params: { id: props.draftId } }, () => {
          proxy.$nextTick(() => {
            EventBus.$emit('show-success', typeof message === 'string' ? message : 'The event has been saved.')
          })
        })
      }
    }

    return {
      eventTypes,
      loadingTypes,
      isCombined,
      events,
      sharedForm,
      errors,
      submitting,
      alert,
      availableJudges,
      loadingJudges,
      judgeIds,
      searchJudges,
      updateJudgeSelection,
      updateEvent,
      onCombinedToggle,
      onUpdateShared,
      onLogoChange,
      handleSubmit
    }
  }
})
</script>




// WEBPACK FOOTER //
// src/views/Drafts/Events/SecretaryEventCreate.vue